<template>
  <transition name="el-notification-fade">
    <div
      v-show="visible"
      :class="['el-notification', customClass, notificationType, horizontalClass, {'has-close': showClose}]"
      :style="positionStyle"
      :qaid="qaid"
      role="alert"
      @mouseenter="clearTimer()"
      @mouseleave="startTimer()"
      @click="click"
    >
      <i
        v-if="iconName || iconClass || icon"
        class="el-notification__icon material-icons"
        :class="[typeClass, iconClass]"
      >
        {{ iconName }}
      </i>
      <div class="el-notification__group" :class="[{'is-with-icon': typeClass || iconClass}]">
        <div v-show="message" class="el-notification__content">
          <h2 v-if="title.length > 0" class="el-notification__title" v-text="title"></h2>
          <slot>
            <div class="flex justify-between">
              <p v-if="!dangerouslyUseHTMLString" class="flex">{{ message }}</p>
              <p v-else v-html="message"></p>
              <a
                v-if="actionClick"
                role="button"
                class="underline hover:no-underline text-success"
                @click.prevent="onActionClick"
                v-html="actionClickText"
              />
            </div>
          </slot>
        </div>
        <div v-if="action" class="el-notification__actions">
          <slot name="action">
            <p v-if="!dangerouslyUseHTMLString">{{ action }}</p>
            <p v-else v-html="action"></p>
          </slot>
        </div>
        <div v-if="link" class="el-notification__actions">
          <a class="underline" :href="link.target">{{ link.basePropertyValue }}</a>
        </div>
        <div v-if="showClose" class="el-notification__closeBtn" @click.stop="close">
          <i class="material-icons">close</i>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/babel">
let typeMap = {
  success: 'success',
  primary: 'primary',
  info: 'primary',
  warning: 'warning',
  alert: 'alert',
};

let iconMap = {
  success: 'done',
  primary: 'info',
  info: 'info',
  warning: 'error',
  alert: 'warning',
};

export default {
  data() {
    return {
      visible: false,
      title: '',
      message: '',
      action: '',
      actionClickText: null,
      actionClick: null,
      duration: 4500,
      showClose: false,
      customClass: '',
      icon: '',
      iconClass: '',
      onClose: null,
      onClick: null,
      closed: false,
      verticalOffset: 0,
      timer: null,
      type: 'primary',
      dangerouslyUseHTMLString: false,
      position: 'top-right',
      link: null,
      qaid: '',
    };
  },

  computed: {
    typeClass() {
      return this.type && typeMap[this.type] ? `text-${typeMap[this.type]}` : '';
    },

    iconName() {
      if (this.icon.length > 0) {
        return this.icon;
      }
      return this.type && iconMap[this.type] ? `${iconMap[this.type]}` : '';
    },

    notificationType() {
      return this.type && typeMap[this.type] ? `el-notification--${typeMap[this.type]}` : '';
    },

    horizontalClass() {
      return this.position.indexOf('right') > -1 ? 'right' : 'left';
    },

    verticalProperty() {
      return /^top-/.test(this.position) ? 'top' : 'bottom';
    },

    positionStyle() {
      return {
        [this.verticalProperty]: `${this.verticalOffset}px`,
      };
    },
  },

  watch: {
    closed(newVal) {
      if (newVal) {
        this.visible = false;
        this.$el.addEventListener('transitionend', this.destroyElement);
      }
    },
  },

  mounted() {
    if (this.duration > 0) {
      this.timer = setTimeout(() => {
        if (!this.closed) {
          this.close();
        }
      }, this.duration);
    }

    document.addEventListener('keydown', this.keydown);
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.keydown);
  },

  methods: {
    destroyElement() {
      this.$el.removeEventListener('transitionend', this.destroyElement);
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },

    click() {
      if (typeof this.onClick === 'function') {
        this.onClick();
      }
    },

    onActionClick() {
      if (typeof this.actionClick === 'function') {
        this.actionClick();
        this.close();
      }
    },

    close() {
      this.closed = true;
      if (typeof this.onClose === 'function') {
        this.onClose();
      }
    },

    clearTimer() {
      clearTimeout(this.timer);
    },

    startTimer() {
      if (this.duration > 0) {
        this.timer = setTimeout(() => {
          if (!this.closed) {
            this.close();
          }
        }, this.duration);
      }
    },

    keydown(e) {
      if (e.keyCode === 46 || e.keyCode === 8) {
        this.clearTimer();
      } else if (e.keyCode === 27) {
        if (!this.closed) {
          this.close();
        }
      } else {
        this.startTimer();
      }
    },
  },
};
</script>
